'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FileCloudCircle = function FileCloudCircle(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm4.5 14H8c-1.66 0-3-1.34-3-3s1.34-3 3-3l.14.01C8.58 8.28 10.13 7 12 7c2.21 0 4 1.79 4 4h.5c1.38 0 2.5 1.12 2.5 2.5S17.88 16 16.5 16z' })
  );
};
FileCloudCircle = (0, _pure2.default)(FileCloudCircle);
FileCloudCircle.displayName = 'FileCloudCircle';
FileCloudCircle.muiName = 'SvgIcon';

exports.default = FileCloudCircle;


/*****************
 ** WEBPACK FOOTER
 ** ./~/material-ui/svg-icons/file/cloud-circle.js
 ** module id = 1959
 ** module chunks = 0
 **/